<template>
  <div class="service-file-list-item service-file-list-item-video">
    <div class="top">
      <div>
        <img :src="util.getImageUrl()" />
        <div class="controls" @click="dialogVisible = true">
          <img src="@/assets/service/播放.png" />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>
        <img src="@/assets/service/视频.png" /> 视频
      </div>

      <div class="download" @click="onDownload"></div>
    </div>

    <el-dialog :visible.sync="dialogVisible" fullscreen>
      <div class="video">
        <video
          :id="id"
          :width="width + 'px'"
          :height="height + 'px'"
          autoplay
          controls
          @loadedmetadata="onCanPlay"
        >
          <source :src="util.getImageUrl(item.url)" type="video/mp4" />
        </video>
      </div>

      <!-- <span slot="title"></span>
      <span slot="footer" class="footer"></span>-->
    </el-dialog>
  </div>
</template>

<script>
import UUID from "uuid/v5";
import FileListItem from "./FileListItem";
export default {
  name: "FileListItemVideo",
  extends: FileListItem,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      id: UUID(this.item.url, UUID.URL),
      dialogVisible: false,

      width: 0,
      height: 0
    };
  },
  watch: {
    dialogVisible: function(val) {
      const video = document.getElementById(this.id);

      if (video) {
        if (val) {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  },
  methods: {
    onCanPlay() {
      const video = document.getElementById(this.id);

      const rate = video.videoHeight / video.videoWidth;

      if (rate > 1) {
        this.height = window.innerHeight * 0.9;
        this.width = Math.ceil(this.height / rate);
      } else {
        this.width = window.innerWidth * 0.9;
        this.height = Math.ceil(this.width * rate);
      }
    },
    play() {}
  }
};
</script>

<style lang="scss">
.service-file-list-item-video {
  overflow: hidden;
  position: relative;

  .video {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-dialog {
    padding: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .el-dialog__headerbtn {
    font-size: 20px;
    background: #4e4e4e;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }

  .el-dialog__close {
    color: white;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
  }
}
</style>